module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/340.23ddc293.png";